import { render, staticRenderFns } from "./SoftwareNews.vue?vue&type=template&id=4459dd3d&"
import script from "./SoftwareNews.vue?vue&type=script&lang=js&"
export * from "./SoftwareNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports